<template>
  <div class="dk-megamenu__container">
    <div class="dk-megamenu__item w-full">
      <div class="pb-20">
        <div class="grid grid-cols-5">
          <MegamenuLocationGroups
            v-for="location in secondLocationGroup"
            :key="location.order"
            :id="location.locationName ? location.locationName : 'europe'"
            :locationGroup="location"
            @clickLocationLink="$emit('clickLocationLink', $event)"
          >
          </MegamenuLocationGroups>
        </div>
        <div class="relative flex">
          <MegamenuLocationGroups
            :locationGroup="firstLocationGroup[0]"
            :contactFooterNavigationTree="contactNavigationTree"
            @clickLocationLink="$emit('clickLocationLink', $event)"
          >
          </MegamenuLocationGroups>
          <SvgWorldMap
            class="dk-megamenu__world-map flex-grow text-blue-dark"
          ></SvgWorldMap>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import MegamenuLocationGroups from '@/components/navbar/MegamenuLocationGroups.vue';
import MegamenuLocationGroup from '@/components/navbar/MegamenuLocationGroup.vue';
import ContactLocationSwitcher from '@/components/ContactLocationSwitcher.vue';
import { NavigationTreeItem } from '@/store/navigation/models/NavigationTreeItem';
import { NavigationTree } from '@/store/navigation/models/NavigationTree';
import { LocationGroup } from '@/store/navigation/models/LocationGroup';
import SvgWorldMap from '@/components/SvgWorldMap.vue';

@Component({
  components: {
    MegamenuLocationGroups,
    ContactLocationSwitcher,
    SvgWorldMap,
    MegamenuLocationGroup,
  },
  emits: ['clickLocationLink'],
})
export default class MegamenuLocationOverview extends Vue {
  @Prop() navigationTreeItem!: NavigationTreeItem;
  @Prop({ default: [] }) locationGroups!: LocationGroup[];
  @Prop({ default: [] }) contactNavigationTree: NavigationTree = [];

  get firstLocationGroup(): LocationGroup[] {
    return this.locationGroups.slice(0, 1);
  }

  get secondLocationGroup(): LocationGroup[] {
    return this.locationGroups.slice(1);
  }
}
</script>

<style lang="postcss" scoped>
.dk-megamenu__container {
  @apply bg-white px-32;
  color: inherit;
}

.dk-megamenu__world-map {
  max-height: 300px;

  @screen xl {
    @apply absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -40%);
  }
}
</style>
